//@ts-ignore
import { actions as LKModalActions } from 'shared/LKModal'

export const open = (params) => LKModalActions.open(params)
